import Browser from './browser';
import StaticIdSingletonClass from './static-id';
/**
 * Enable console log based on the debug flag.
 */
const LOGGER_STYLE = 'font-weight: bold';

const collapsedlogger = (...args) => {
  /*eslint-disable no-console*/
  if (StaticIdSingletonClass.debug || window.VISA_SDK_DEBUG) {
    const isIEOrEdge = Browser.checkIE11OrEdgeBrowser();
    // Edge doesn't like groupCollapsed and apps might override window.console to remove groupCollapsed support
    const mustUseConsoleLog = isIEOrEdge || !console.groupCollapsed;

    mustUseConsoleLog
      ? console.log('BEGIN::Visa SRC SYSTEM SDK --', args[0])
      : console.groupCollapsed('%cVisa SRC SYSTEM SDK --', LOGGER_STYLE, args[0]);
    for (let i = 1; i < args.length; i++) {
      const data = args[i];
      if (data && data.document && data.alert && data.setInterval) {
        // checking if window reference, since JSON.stringify(window) throws an error.
        console.log(data.name);
        continue;
      }
      if (typeof data === 'object') {
        try {
          console.log(JSON.stringify(data));
          console.log(data);
        } catch (e) {
          console.log('unable to JSON.stringify data');
          continue;
        }
      } else {
        console.log(data);
      }
    }
    mustUseConsoleLog ? console.log('END::Visa SRC SYSTEM SDK --', args[0]) : console.groupEnd();
  }
};

export default collapsedlogger;
